import userApi from '@/api/user'
import authApi from '@/api/auth'
import { user as UserModel } from '@/api/models'
import { mergeUserContext } from '@/store/helpers'

// initial state
const state = {
  // authUserInfo: {},
  forgotPasswordResponse: null,
  resetPasswordSuccess: false,
  emailSentSuccess: null,
  emailSentFailure: null,
  emailSentInProcess: false,

  viewUser: Object.assign({}, UserModel),
  viewUserPending: false,
  viewUserFailure: false,
  viewUserSuccess: false,

  createUser: Object.assign({}, UserModel),
  createUserPending: false,
  createUserFailure: false,
  createUserSuccess: false,

  editUser: Object.assign({}, UserModel),
  updateUserPending: false,
  updateUserFailure: false,
  updateUserSuccess: false,

  recentlyCreatedUser: false,
  userOrganizationGroups: [],
  authenticatedUserMemberships: [],
  authenticatedUserMemberGroups: [],
  userContextOptions: [],
  userCurrentContext: false,
  userRecordCount: 0,
  errors: [],
  users: [],

  deactivateUsersSuccess: false,
  deactivateUsersError: false
}

// getters
const getters = {
  // authUserInfo: state => state.authUserInfo,
  forgotPasswordResponse: state => state.forgotPasswordResponse,
  getResetPasswordSuccess: state => state.resetPasswordSuccess,
  getEmailSentFailure: state => state.emailSentFailure,
  getEmailSentSuccess: state => state.emailSentSuccess,
  getEmailSentInProcess: state => state.emailSentInProcess,

  getCreateUser: state => state.createUser,
  createUserPending: state => state.createUserPending,
  createUserFailure: state => state.createUserFailure,
  createUserSuccess: state => state.createUserSuccess,

  getViewUser: state => state.viewUser,
  viewUserPending: state => state.viewUserPending,
  viewUserFailure: state => state.viewUserFailure,
  viewUserSuccess: state => state.viewUserSuccess,

  getEditUser: state => state.editUser,
  updateUserPending: state => state.updateUserPending,
  updateUserFailure: state => state.updateUserFailure,
  updateUserSuccess: state => state.updateUserSuccess,

  getRecentlyCreatedUser: state => state.recentlyCreatedUser,
  /* COMMENTING OUT userShareAllowedGroups
  Deprecated by store/organization.js getGroupsByOrg

   * Given a User's current organizational context,
   * and the record's owningOrganization,
   * what groups are they allowed to share with?

  userShareAllowedGroups: (state) => async (owningOrgId) => {
    let filteredGroups = []
    let orgGroupArray = []
    let userGroupArray = []
    let request = {
      id: owningOrgId
    }
    let memberGroups = await organizationApi.findGroupMemberships(request)
    let allGroups = await groupApi.getGroups(owningOrgId)
    let userAllowed = true

    First is the user allowed to do this
    const membership = state.authenticatedUserMemberships.find((um) => um.morganization.id === owningOrgId && um.isOrgAdmin)
    if (!membership || !membership.isOrgAdmin) {
      userAllowed = false
    }

    console.log('IN userShareAllowedGroups')
    console.log('userAllowed: ' + userAllowed)
    console.log('allGroups', allGroups)
    console.log('memberGroups', memberGroups)

    if (userAllowed) {
      const orgGroupOptions = allGroups.filter((og) => og.membersOrgs.id === owningOrgId)
      console.log('orgGroupOptions', orgGroupOptions)
      const orgGroups = orgGroupOptions.map((og) => og.group)
      console.log('orgGroups', orgGroups)
      orgGroupArray = _.uniqWith(orgGroups, _.isEqual)
      console.log('orgGroupArray', orgGroupArray)
      filteredGroups = orgGroupArray

      if (orgGroupArray.length) {
        if (state.userCurrentContext) {
          if (state.userContextOptions) {
            const userOptions = state.userContextOptions.filter((og) => og.group.id !== 0)
            const userGroups = userOptions.map((og) => og.group)
            userGroupArray = _.uniqWith(userGroups, _.isEqual)
            console.log('userGroupArray: ' + userGroupArray)
            // Only use orgGroupArray items that are also in the userGroupArray
            orgGroupArray.forEach(function (item) {
              console.log('matching for: ' + item)
              const match = userGroupArray.find((name) => name === item)
              if (match) {
                console.log('matching found: ' + item)
                filteredGroups.push(item)
              }
            })
            filteredGroups = userGroupArray
          }
        }
      }
    }

    OLD CODE - BASED ON USER CONTEXT
    if (state.userCurrentContext) {
      if (state.userContextOptions) {
        const filteredOptions = state.userContextOptions.filter((og) => og.group.id !== 0)
        const groups = filteredOptions.map((og) => og.group)
        filteredGroups = _.uniqWith(groups, _.isEqual)
      }
    }

    return filteredGroups
  },
  */

  /*
  I think that we use the OwningOrganization object, to determine a list of Groups, then pull together a distinct list of Organization... the user membership is a controller issue - only if isOrgAdmin=true for current Owning Org is eligible to do a transfer.
  */
  userTransferAllowed: (state) => (owningOrgId) => {
    const membership = state.authenticatedUserMemberships.find((um) => um.morganization.id === owningOrgId && um.isOrgAdmin)
    if (!membership || !membership.isOrgAdmin) {
      return false
    }

    return true
  },
  authenticatedUserMemberships: state => state.authenticatedUserMemberships,
  userContextOptions: state => state.userContextOptions,
  userCurrentContext: state => state.userCurrentContext,
  getUserRecordCount: state => state.userRecordCount,
  getUser: state => state.users,
  getUpdateUserResponse: state => state.updateUserResponse,
  getDeactivateUsersSuccess: state => state.deactivateUsersSuccess,
  getDeactivateUsersError: state => state.deactivateUsersError
}

// actions
const actions = {
  async initializeUser ({ commit, state }, payload) {
    const user = payload

    // Setup Memberships
    const memberships = _.get(user, 'userMemberships', [])
    if (memberships.length > 0) {
      commit('SET_USER_MEMBERSHIPS', memberships)
    }

    // Setup Groups
    const userOrganizationGroups = _.get(user, 'userOrganizationGroups', [])
    if (userOrganizationGroups.length > 0) {
      commit('SET_USER_ORGANIZATION_GROUPS', userOrganizationGroups)
      commit('SET_USER_MEMBER_GROUPS')
      commit('SET_USER_CONTEXT_OPTIONS')
    }

    // initializeUserContext(user, memberships)
    commit('INITIALIZE_USER_CONTEXT', { user })
  },

  // Reset User - Used after a membership change via Global EventBus Trigger
  async resetUser ({ commit, state, dispatch }, payload) {
    const token = this._vm.$auth.token()
    const userResponse = await authApi.getAuthUser({ payload: token })
    const user = userResponse.body

    dispatch('initializeUser', user)
    commit('REBUILD_USER_CONTEXT', { user })
  },

  // Create
  async createUser ({commit, rootState}, payload) {
    commit('SET_USER_STATE', { field: 'createUserPending', value: true })

    delete payload.id
    payload = mergeUserContext(payload, rootState)

    let response = await userApi.createUser(payload)
    commit('SET_USER_STATE', { field: 'createUserPending', value: false })

    if (response.status !== 200 || response.error) {
      console.log('fail respomse>>>', response)
      if (response.body.details) {
        commit('SET_USER_STATE', { field: 'createUserFailure', value: response.body.details })
      } else {
        commit('SET_USER_STATE', { field: 'createUserFailure', value: this._vm.$utils.errorToHtml(response.body) })
      }
      return
    }

    commit('SET_USER_STATE', { field: 'createUserSuccess', value: response.body })
    commit('SET_SUCCESSFULLY_CREATED_USER', response.body)
    commit('ADD_TO_USERS_LIST', response.body)
    commit('RESET_CREATE_USER')
  },

  async bulkCreateUsers ({ commit, rootState }, payload) {
    commit('SET_USER_STATE', { field: 'createUserPending', value: true })

    delete payload.id
    payload = mergeUserContext(payload, rootState)

    const response = await userApi.bulkCreateUsers(payload)
    commit('SET_USER_STATE', { field: 'createUserPending', value: false })

    if (response.status !== 200 || response.error) {
      const message = response.body.details || this._vm.$utils.errorToHtml(response.body)
      commit('SET_USER_STATE', { field: 'createUserFailure', value: message })
      return
    }

    const createdUser = response.body.users[0]
    commit('SET_USER_STATE', { field: 'createUserSuccess', value: createdUser })
    commit('SET_SUCCESSFULLY_CREATED_USER', createdUser)
    commit('RESET_CREATE_USER')

    return response.body.users
  },

  // Update
  async updateUser ({ commit, state, rootState }, payload) {
    commit('SET_USER_STATE', { field: 'updateUserPending', value: true })
    console.log('payload for update user', payload)
    let response = await userApi.updateUser(payload)
    commit('SET_USER_STATE', { field: 'updateUserPending', value: false })
    if (response.status !== 200) {
      if (response.body.details) {
        commit('SET_USER_STATE', { field: 'updateUserFailure', value: response.body.details })
      } else {
        commit('SET_USER_STATE', { field: 'updateUserFailure', value: this._vm.$utils.errorToHtml(response.body) })
      }

      return
    }

    commit('SET_USER', response.body)
    commit('SET_USER_STATE', { field: 'updateUserSuccess', value: response.body })
    commit('SET_USER_STATE', { field: 'updateUserPending', value: false })
  },

  // Single View
  async getUser ({ commit, state, rootState }, payload) {
    let response = await userApi.getUser(payload)
    response = response.body

    if (_.isArray(response)) {
      response = response.pop()
    }

    commit('SET_USER', response)
  },

  // Single View - Edit
  async getUserForEdit ({ commit, state, rootState }, payload) {
    let response = await userApi.getUser(payload)
    response = response.body

    if (_.isArray(response)) {
      response = response.pop()
    }
    commit('SET_EDIT_USER', response)
  },

  async userAcceptedTos ({ commit, state }, payload) {
    let response = await userApi.userAcceptedTos(payload)
    response = response.body

    commit('setUserAcceptedTos', response)
  },
  async userAcceptedEUA ({ commit, state }, payload) {
    let response = await userApi.userAcceptedEUA(payload)
    response = response.body
    commit('setUserEUA', response)
  },
  async sendPasswordResetEmail ({ commit, state }, payload) {
    commit('setEmailSentInProcess', true)
    let response = await userApi.sendPasswordResetEmail(payload)
    commit('setEmailSentInProcess', false)
    if (response.body.success) {
      commit('setEmailSentSuccess', response.body.message)
    } else {
      commit('setEmailSentFailure', response.body.message)
    }
  },
  async submitForgotPassword ({commit, state}, payload) {
    let response = await userApi.submitForgotPassword(payload)
    // response = response.body

    commit('setForgotPasswordResponse', response)
  },

  async resetPassword ({ commit, state }, payload) {
    let response = await userApi.resetPassword(payload)
    response = response.body

    commit('resetPasswordSuccess', response)
  },

  async sendWelcomeEmail ({ commit, state }, payload) {
    commit('setEmailSentInProcess', true)
    let response = await userApi.sendWelcomeEmail(payload)
    commit('setEmailSentInProcess', false)
    if (response.body.success) {
      commit('setEmailSentSuccess', response.body.message)
      if (response.body.user) {
        commit('SET_USER', response.body.user)
      }
    } else {
      commit('setEmailSentFailure', response.body.message)
    }
  },

  async bulkSendWelcomeEmail ({ commit }, payload) {
    commit('setEmailSentInProcess', true)
    const response = await userApi.bulkSendWelcomeEmail(payload)

    commit('setEmailSentInProcess', false)
    console.log('response', response)
    if (response.body.success) {
      commit('setEmailSentSuccess', response.body.message)
    } else {
      commit('setEmailSentFailure', response.body.message)
    }
  },

  async getUserRecordCount ({ commit, state, rootState }, payload) {
    payload = mergeUserContext(payload, rootState)

    let response = await userApi.getUserRecordCount(payload)
    response = response.body

    commit('SET_USER_RECORD_COUNT', response.data)
    return response.data
  },

  // Search
  async getUsers ({ commit, state, rootState }, payload) {
    payload = mergeUserContext(payload, rootState)

    var response = await userApi.getUserDashboard(payload)

    if (response.ok) {
      commit('SET_ALL_SEARCH_USERS', response.body)
    }
    return response.body
  },

  initDeactivateUsersResponse ({ commit }) {
    commit('SET_DEACTIVATE_USERS_SUCCESS', false)
    commit('SET_DEACTIVATE_USERS_ERROR', false)
  },

  async deactivateUsers ({ commit, state, rootState }, payload) {
    payload = mergeUserContext(payload, rootState)
    const response = await userApi.deactivateUsers(payload)
    if (response.ok) {
      commit('SET_ALL_SEARCH_USERS', response.body.users)
      commit('SET_DEACTIVATE_USERS_SUCCESS', true)
    } else {
      commit('SET_DEACTIVATE_USERS_ERROR', response.body.error)
    }
  }
}

// mutations
const mutations = {
  // updateAuthUserInfo (state, payload) {
  //   state.authUserInfo = payload
  // },

  resetEmailUserView (state) {
    state.emailSentFailure = null
    state.emailSentSuccess = null
    state.emailSentInProcess = false
  },

  resetViewUser (state) {
    state.viewUser = Object.assign({}, UserModel)
  },

  resetAddUser (state) {
    state.createUser = Object.assign({}, UserModel)
    state.createUserPending = false
    state.createUserFailure = false
    state.createUserSuccess = false
  },

  resetEditUser (state) {
    state.editUser = Object.assign({}, UserModel)
    state.updateUserPending = false
    state.updateUserFailure = false
    state.updateUserSuccess = false
  },

  setEmailSentInProcess (state, response) {
    state.emailSentInProcess = response
  },

  setForgotPasswordResponse (state, response) {
    state.forgotPasswordResponse = response
  },

  resetPasswordSuccess (state, response) {
    state.resetPasswordSuccess = true
  },

  setEmailSentFailure (state, response) {
    state.emailSentFailure = response
    state.emailSentSuccess = false
  },

  setEmailSentSuccess (state, response) {
    state.emailSentSuccess = response
    state.emailSentFailure = false
  },

  setUserAcceptedTos (state, response) {
    // It doesn't matter what we set this too, it will get refreshed from the server
    // It just needs to be greater than 0, so we don't spam the user with the consent window again
    const now = Math.round(Date.now() / 1000)
    this._vm.$auth.user({ acceptedTosAt: now })
  },

  setUserEUA (state, response) {
    this._vm.$auth.user({ acceptedEUA: 1 })
  },

  SET_SUCCESSFULLY_CREATED_USER (state, record) {
    state.recentlyCreatedUser = record
  },

  ADD_TO_USERS_LIST (state, newRecord) {
    var oldIndex = _.findIndex(state.users, (r) => r._id === newRecord._id)

    if (oldIndex < 0) {
      state.users.unshift(newRecord)
    } else {
      // Uh-oh - we tried to add a record that's already in our list
    }
  },

  RESET_CREATE_USER (state) {
    state.createUser = Object.assign({}, UserModel)
  },

  SET_USER (state, record) {
    if (_.isEmpty(record)) {
      state.viewUser = Object.assign({}, UserModel)
    } else {
      if (record.primaryOrganization.isRemoved) {
        record.primaryOrganization = {}
      }
      state.viewUser = record
    }
  },

  SET_EDIT_USER (state, record) {
    state.editUser = record
  },

  INITIALIZE_USER_CONTEXT (state, payload) {
    if (state.userCurrentContext) {
      console.log('Context has already been initialized, preserving current context')
    }

    if (!state.userCurrentContext) {
      let { user } = payload
      let initialContext = false
      let umogs = state.userContextOptions

      if (umogs.length > 0) {
        initialContext = umogs[0]
      }

      const userPrimaryOrganization = _.get(user, 'primaryOrganization', 0)
      if (userPrimaryOrganization) {
        initialContext = state.userContextOptions.find((umog) => umog.organization.id === userPrimaryOrganization.id && !umog.group.id)
      }

      if (initialContext) {
        state.userCurrentContext = initialContext
        console.log("Initializing organization context to the user's primary organization - " + userPrimaryOrganization.title)
      } else {
        console.log("No group/organizational context established given the user's data")
      }
    }
  },

  REBUILD_USER_CONTEXT (state, payload) {
    let { user } = payload
    let initialContext = false
    let umogs = state.userContextOptions

    if (umogs.length > 0) {
      initialContext = umogs[0]
    }

    const userPrimaryOrganization = _.get(user, 'primaryOrganization', 0)
    if (userPrimaryOrganization) {
      // Find _first_ group for the User's primary organization
      initialContext = state.userContextOptions.find((umog) => umog.organization.id === userPrimaryOrganization.id)
    }

    if (initialContext) {
      state.userCurrentContext = initialContext
      console.log("Initializing organization context to the user's primary organization - " + userPrimaryOrganization.title)
    } else {
      console.log("No group/organizational context established given the user's data")
    }
  },

  SET_USER_MEMBER_GROUPS (state) {
    const memberGroups = state.userOrganizationGroups.reduce((acc, mo) => {
      acc.push(...mo.memberGroups)
      return acc
    }, [])

    state.authenticatedUserMemberGroups = _.uniqWith(memberGroups, _.isEqual)
  },

  SET_USER_ORGANIZATION_GROUPS (state, userOrganizationGroups) {
    state.userOrganizationGroups = userOrganizationGroups
  },

  SET_USER_CONTEXT_OPTIONS (state) {
    const userMemberships = state.authenticatedUserMemberships

    const combos = state.userOrganizationGroups.reduce((acc, org) => {
      const organization = Object.assign({}, org)
      delete organization.memberGroups

      const list = org.memberGroups.map((group) => {
        const obj = {
          organization: organization,
          group: group,
          label: group.groupName + ' : ' + organization.title
        }

        const userMember = userMemberships.find((um) => um.morganization.id === organization.id)
        obj.userMember = userMember || false

        return obj
      })

      const orgOnly = {
        organization: organization,
        group: { id: 0 },
        label: organization.title
      }

      const userMember = userMemberships.find((um) => um.morganization.id === organization.id)
      orgOnly.userMember = userMember || false

      acc.push(...list)
      acc.push(orgOnly)
      return acc
    }, [])

    state.userContextOptions = combos
  },

  SET_USER_MEMBERSHIPS (state, payload) {
    state.authenticatedUserMemberships = payload
  },

  SET_USER_CONTEXT (state, payload) {
    state.userCurrentContext = Object.assign({}, payload)
  },

  RESET_USER_CONTEXT (state, payload) {
    state.userCurrentContext = false
  },

  SET_USER_RECORD_COUNT (state, count) {
    state.userRecordCount = count
  },

  SET_ALL_SEARCH_USERS (state, records) {
    if (records) {
      records.forEach(record => {
        if (
          record.primaryOrganization &&
          record.primaryOrganization.isRemoved
        ) {
          record.primaryOrganization = {
            title: ''
          }
        }
      })
    }
    state.users = records || []
  },

  SET_USER_STATE (state, payload) {
    const { field, value } = payload
    state[field] = value
  },

  SET_DEACTIVATE_USERS_SUCCESS (state, payload) {
    state.deactivateUsersSuccess = payload
  },

  SET_DEACTIVATE_USERS_ERROR (state, payload) {
    state.deactivateUsersError = payload
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/user.js